import React, { useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import ProductSearch from '../../Components/ProductSearch/index'
import { ENUM_MENU } from '../../Utils/constants'
import { drugInteraction } from '../../Utils/api'
import { addEventNameWithParams, logEvent } from '../../Utils/utils'
import { changeInitialLoading } from '../../redux/modules/app'
import { useDispatch, useSelector } from 'react-redux'
import parse from 'html-react-parser'
import FailDrugsInteraction from './FailDrugsInteraction'

const currentYear = new Date().getFullYear()

const ageRange = Array.from({ length: 122 }, (_, index) => index + 1)
const weightRange = Array.from({ length: 250 }, (_, index) => index + 1)
const heightRange = Array.from({ length: 271 }, (_, index) => index + 30)

function DrugsInteractions() {
  const dispatch = useDispatch()
  const loading = useSelector((state) => state.app.initial_loading)
  const [productList, setProductList] = useState([])
  const [gender, setGender] = useState(null)
  const [weight, setWeight] = useState(null)
  const [age, setAge] = useState(null)
  const [height, setHeight] = useState(null)
  const [pregnancy, setPregnancy] = useState(false)
  const [lactancy, setLactancy] = useState(false)
  const [html, setHtml] = useState(null)
  const history = useHistory()
  const pregnancyRef = useRef()
  const lactancyRef = useRef()
  const genderRef = useRef()
  const weightRef = useRef()
  const heightRef = useRef()
  const birthDayRef = useRef()
  const fromYappApp = localStorage.getItem('fromYappApp') === 'true'
  const goBack = () => {
    history.goBack()
  }

  useEffect(() => {
    let dataProduct = history.location.state?.data_product
  }, [])

  useEffect(() => {
    setHtml(null)
  }, [productList])

  const dataValidation = async () => {
    setHtml(null)
    dispatch(changeInitialLoading(true))
    logEvent('Drug Interaction Checked', {
      'Product Quantity': productList.length
    })
    const info = {
      products: productList.map((p) => {
        logEvent('Drug Interaction Product Checked', {
          'Product Id': p.product_id,
          'Product Name': p.product_name,
          'Lab Name': p.laboratory_name,
          // TODO:
          // Active Principle Id
          // Active Principle Name
          // Category Id
          // Category Name
          // Lab Id
        })
        return p.product_id
      }),
      gender: gender,
      weight: weight,
      birth_day: age
        ? new Date(`${currentYear - age}-06-25T00:00:00+00:00`)
        : null,
      height: height,
      pregnancy: pregnancy,
      lactancy: lactancy ? 'ALL' : null,
    }
    try {
      const response = await drugInteraction(info)
      setHtml(response)
    } catch (error) {
      console.log(error)
    }
    dispatch(changeInitialLoading(false))
    dataLayerFn()
  }

  function dataLayerFn() {
    let products = productList.map((p) => {
      return { product_id: p.product_id, product_name: p.product_name }
    })
    addEventNameWithParams('analysis_drug_interactions', {
      interaction_gender: gender,
      interaction_height: height,
      interaction_weight: weight,
      interaction_age: age,
      interaction_lactancy: lactancy,
      products: products,
    })
  }

  const removeFromProductList = (index) => {
    let array = [...productList]
    array.splice(index, 1)
    setProductList(array)
  }

  const onClickSearch = (product) => {
    if (product?.value) {
      const productId = productList.find((p) => p.product_id === product.value)
      addEventNameWithParams('drugs_interaction_selected_product', {
        product_id: product?.value,
        product_name: product.label,
      })

      if (!productId) {
        setProductList([...productList, product.data])
      } else {
        console.log('Error value')
      }
    }
  }

  const genderSelection = (value) => {
    setGender(value)
    if (value === 'MALE' && pregnancy) pregnancyRef.current.click()
    if (value === 'MALE' && lactancy) lactancyRef.current.click()
  }

  const onClear = () => {
    setGender(null)
    setWeight(null)
    setAge(null)
    setHeight(null)
    genderRef.current.value = ''
    weightRef.current.value = ''
    heightRef.current.value = ''
    birthDayRef.current.value = ''
    if (lactancyRef.current.checked) {
      lactancyRef.current.checked = false
    }
    setHtml(null)
  }

  return (
    <>
      {!fromYappApp && (
        <div className='py-3 px-3'>
          <div className="content-responsive mx-auto d-flex justify-content-between ">
            <div className="breadcrumbs c-pointer" onClick={goBack}>
              <a className="d-flex align-items-center">
                <i className="icon-chevron-right icon-reverse"></i>
              </a>
              <span className="title-primary--regular line-14">Volver</span>
            </div>
          </div>
        </div>
      )}
      {false ? (
        <FailDrugsInteraction />
      ) : (
        <div className="flex-grow-1 px-3">
          <div className="content-responsive mx-auto pt-4">
            <h2 className="title-primary--xxl mb-2">
              Interacciones medicamentosas
            </h2>
            <p className="txt-paragraph mb-3">
              Revisa aquí las interacciones entre medicamentos y también
              obtendrás información sobre contraindicaciones en el embarazo, e
              interacciones entre medicamentos y alimentos.{' '}
            </p>
            <div className="d-flex align-items-center justify-content-between">
              <h2 className="txt-paragraph--bold m-0 ">
                Info del paciente (opcional)
              </h2>
              <a className="txt-paragraph color-lilac " onClick={onClear}>
                Borrar todo
              </a>
            </div>
            <div className="pb-2 pt-3 content-patient-info">
              <div className="select-custom-altern">
                <span className="label">Sexo</span>
                <select
                  ref={genderRef}
                  id="gtm-webapp-drugs-interactive-gender"
                  onChange={(evt) => (
                    genderSelection(evt.target.value), setHtml(null)
                  )}>
                  <option value="" selected>
                    -
                  </option>
                  <option value={'MALE'}>Hombre</option>
                  <option value={'FEMALE'}>Mujer</option>
                </select>
              </div>
              <div className="select-custom-altern">
                <span className="label">Peso</span>
                <select
                  ref={weightRef}
                  id="gtm-webapp-drugs-interactive-weight"
                  onChange={(evt) => (
                    setWeight(evt.target.value.split(' ')[0]), setHtml(null)
                  )}>
                  <option value="" selected>
                    -
                  </option>
                  {weightRange.map((value, key) => (
                    <option key={key}>{value} kg</option>
                  ))}
                </select>
              </div>
              <div className="select-custom-altern">
                <span className="label">Edad</span>
                <select
                  ref={birthDayRef}
                  id="gtm-webapp-drugs-interactive-age"
                  onChange={(evt) => (
                    setAge(evt.target.value.split(' ')[0]), setHtml(null)
                  )}>
                  <option value="" selected>
                    -
                  </option>
                  {ageRange.map((value, key) => (
                    <option key={key}>{value} años</option>
                  ))}
                </select>
              </div>
              <div className="select-custom-altern">
                <span className="label">Altura</span>
                <select
                  ref={heightRef}
                  id="gtm-webapp-drugs-interactive-height"
                  onChange={(evt) => (
                    setHeight(evt.target.value.split(' ')[0]), setHtml(null)
                  )}>
                  <option value="" selected>
                    -
                  </option>
                  {heightRange.map((value, key) => (
                    <option key={key}>{value} cm</option>
                  ))}
                </select>
              </div>
              <div className="d-flex align-items-center">
                <label
                  className="custom-checkbox-altern"
                  id="gtm-webapp-drugs-interactive-lactation">
                  <input
                    ref={lactancyRef}
                    disabled={['MALE', 'NONE', null].includes(gender)}
                    type="checkbox"
                    onChange={(evt) => (
                      setLactancy(evt.target.checked), setHtml(null)
                    )}
                  />
                  <span className="checkmark-altern">
                    <i className="icon-checkmark"></i>
                  </span>
                  <span className="txt-paragraph custom-checkbox-txt">
                    Lactancia
                  </span>
                </label>
                <label
                  className="custom-checkbox-altern"
                  id="gtm-webapp-drugs-interactive-pregnancy"></label>
              </div>
            </div>

            <h2 className="txt-paragraph--bold mb-2 ">
              Medicamentos a interactuar{' '}
            </h2>
            <p className="txt-paragraph mb-3">Agrega mínimo 2 medicamentos </p>
            {productList.map((product, index) => (
              <span key={index} className="tag-result mr-2 mb-2">
                {product.product_name}
                <i
                  className="icon-close c-pointer color-lilac ml-2"
                  onClick={() => removeFromProductList(index)}></i>
              </span>
            ))}
            <div className="content-drug-interacion-search">
              <ProductSearch
                styleSecondary={true}
                showValue={true}
                request_from={ENUM_MENU.drug_interactions}
                onClickSearch={onClickSearch}
                isNotShow={true}
                placeholder={'Busca por marca o principio activo'}
                vidal={1}
                clearInput={true}
              />
            </div>
            <button
              id="gtm-webapp-drugs-interactive-btn-analysis"
              className="btn-default btn-next mx-auto mt-2 mb-4"
              disabled={!(productList.length > 1) || loading}
              onClick={() => dataValidation()}>
              Ver análisis de interacciones
            </button>
          </div>
          {html && (
            <div className="content-responsive mx-auto"> {parse(html)}</div>
          )}
        </div>
      )}
    </>
  )
}

export default DrugsInteractions
